import { Check } from "lucide-react";

export interface ChipItem {
  id: string;
  name: string;
  description?: string;
}

interface ToggleChipsProps {
  label: string;
  items: ChipItem[];
  activeIds: string[];
  onToggle: (id: string) => void;
  onSetAll: (on: boolean) => void;
}

/** Reusable check/uncheck chip group with All/None controls. */
export default function ToggleChips({
  label,
  items,
  activeIds,
  onToggle,
  onSetAll,
}: ToggleChipsProps) {
  const active = new Set(activeIds);
  return (
    <div>
      <div className="mb-2 flex items-center justify-between">
        <span className="text-xs font-semibold uppercase tracking-wide text-muted">
          {label} · {active.size}/{items.length}
        </span>
        <div className="flex gap-2 text-xs">
          <button onClick={() => onSetAll(true)} className="rounded-md px-2 py-1 text-muted hover:text-text">
            All
          </button>
          <button onClick={() => onSetAll(false)} className="rounded-md px-2 py-1 text-muted hover:text-text">
            None
          </button>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {items.map((item) => {
          const on = active.has(item.id);
          return (
            <button
              key={item.id}
              onClick={() => onToggle(item.id)}
              title={item.description}
              className={[
                "inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-sm transition-colors",
                on
                  ? "border-primary/60 bg-primary/10 text-text"
                  : "border-border bg-surface-2 text-muted hover:text-text",
              ].join(" ")}
            >
              <span
                className={[
                  "grid h-4 w-4 shrink-0 place-items-center rounded border",
                  on ? "border-primary bg-primary text-primary-fg" : "border-border",
                ].join(" ")}
              >
                {on && <Check className="h-3 w-3" />}
              </span>
              {item.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
